import { Button, Logo, LongLeftArrowIcon } from 'components/common'
import React, { ReactChild } from 'react'

type Props = {
  children: ReactChild | ReactChild[]
  buttonText?: string
  prevArrowClick?: () => void
  nextButtonClick?: () => void
  title?: string
  buttonNode?: ReactChild
  disableNextButton?: boolean
  showLeftArrow?: boolean
  titleNode?: ReactChild | null
}

const OrderStepsTemplate = ({
  children,
  buttonText,
  prevArrowClick,
  nextButtonClick,
  disableNextButton,
  title = '',
  buttonNode,
  showLeftArrow = true,
  titleNode = null
}: Props) => {
  return (
    <>
      {showLeftArrow && (
        <LongLeftArrowIcon
          className="absolute left-8 top-6 w-[30px] h-[30px] cursor-pointer"
          onClick={prevArrowClick}
        />
      )}

      <div className="space-y-6 flex flex-col flex-1">
        <div className="flex justify-center">
          <Logo width="166px" height="61px" />
        </div>

        {titleNode}
        {title && <h2 className="text-center">{title}</h2>}

        <div className="flex flex-col flex-1">{children}</div>
      </div>

      <div className="sticky bottom-2 mt-2">
        {buttonNode ? (
          buttonNode
        ) : (
          <Button
            onClick={nextButtonClick}
            text={buttonText}
            variant="active"
            disabled={disableNextButton}
          />
        )}
      </div>
    </>
  )
}

export default OrderStepsTemplate
